import * as React from "react";
import "./ModelUploadIndicator.component.css";
import { useModelUploadStateStore } from "../../../store/model-upload-state.store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModelUploadService } from "../../../services/model-upload.service";
import { useTranslation } from "react-i18next";
export function ModelUploadIndicator() {
    const modelUploadInProgress = useModelUploadStateStore((state) => state.inProgress);
    const uploadType = useModelUploadStateStore((state) => state.type);
    const { t } = useTranslation();
    const getProgressMessage = () => {
        switch (uploadType) {
            case ModelUploadService.FileType.stl:
                return t("sessionview:model-upload-indicator-message-stl", "Uploading STL file...");
            case ModelUploadService.FileType.rosbag:
                return t("sessionview:model-upload-indicator-message-rosbad", "Uploading Rosbag file...");
            default:
                return t("sessionview:model-uploadi-indicator-message-model", "Uploading model...");
        }
    };
    return (React.createElement(React.Fragment, null, modelUploadInProgress && (React.createElement("div", { className: "model-upload-indicator-container" },
        React.createElement(FontAwesomeIcon, { icon: "spinner", spin: true }),
        React.createElement("span", { className: "model-upload-indicator-text" }, getProgressMessage())))));
}
